import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            全网观众都在讨论的影视热点，看看有没有你感兴趣的话题
          </p>
        </div>

        <div className="max-w-4xl mx-auto flex flex-wrap justify-center gap-3">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className={`group inline-flex items-center gap-2 px-5 py-3 rounded-xl border transition-all cursor-pointer ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200/70 hover:border-primary-200 hover:bg-background-50'
              }`}
            >
              <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                {topic.name}
              </span>
              {topic.hot && (
                <span className="inline-flex items-center gap-0.5 text-xs text-primary-500 font-medium">
                  <i className="ri-fire-line"></i>
                </span>
              )}
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}